/** Creates a new "now" date. */
export const nowDate = () => new Date();

export const nowIsoString = () => new Date().toISOString();

export const isoString = (date: Date) => date.toISOString();
